import { render, staticRenderFns } from "./AddPRN.vue?vue&type=template&id=27019351&scoped=true&"
import script from "./AddPRN.vue?vue&type=script&lang=js&"
export * from "./AddPRN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27019351",
  null
  
)

export default component.exports